/**
 * 营销模块 key
 */
export default {
    /* 消息群发 start */
    M_B_P_S: '计划搜索', // 采集时机：输入内容确定筛选后

    M_B_P_C: '创建计划',
    M_B_P_C_0: '创建计划_确定', // 特殊属性：addition：{ channel: '1', // 选中的渠道channel }
    M_B_P_C_1: '创建计划_取消',
    M_B_P_C_0_0: '创建计划_确定_群发计划确定',
    M_B_P_C_0_1: '创建计划_确定_群发计划取消',

    M_B_R: '刷新',

    M_B_C_P: '所有循环计划',
    M_B_C_P_0: '所有循环计划_查看计划内容',
    M_B_C_P_1: '所有循环计划_查看推送数据',
    M_B_C_P_2: '所有循环计划_编辑计划',
    M_B_C_P_3: '所有循环计划_复制计划',
    M_B_C_P_4: '所有循环计划_取消计划',

    M_B_R_B: '回收站',
    M_B_R_B_0: '回收站_恢复',
    M_B_R_B_0_0: '回收站_恢复_确定', // 特殊属性：addition：{ id: '1', // 计划id }

    M_B_B: '批量操作', // 采集时机：hover 鼠标悬浮，触发菜单
    M_B_B_0: '批量_导出最近最大数量',
    M_B_B_1: '批量_导出已选', // 特殊属性：addition: { total: number, is_all: boolean }
    M_B_B_2: '批量_删除',
    M_B_B_2_0: '批量_删除_确定', // 特殊属性：addition: { total: number, is_all: boolean }

    M_B_P_0: '洞察',
    M_B_P_0_0: '洞察_导出',
    M_B_P_1: '费用',
    M_B_P_2: '查看循环计划',
    M_B_P_3: '编辑',
    M_B_P_4: '复制',
    M_B_P_5: '取消',
    M_B_P_5_0: '取消_确定',
    M_B_P_6: '删除',
    M_B_P_6_0: '删除_确定',
    /* 消息群发 end */

    /* 第三方代发 start */
    M_B_E_S: '计划搜索', // 采集时机：输入内容确定筛选后

    M_B_E_C: '创建计划',
    M_B_E_C_0: '创建计划_完成创建',
    M_B_E_C_1: '创建计划_存为草稿',
    M_B_E_C_2: '创建计划_取消',

    M_B_E_R: '功能介绍',

    M_B_E_N: '查看发送数',
    M_B_E_D: '自定义显示列',
    M_B_E_D_0: '自定义显示列_确定',

    M_B_E_P_0: '编辑',
    M_B_E_P_1: '洞察',
    M_B_E_P_1_0: '洞察_导出',
    M_B_E_P_2: '复制',
    M_B_E_P_3: '删除',
    M_B_E_P_3_0: '删除_确定',
    /* 第三方代发 end */

    /* WhatsApp Api模板 start */
    M_B_T_W_S_0: '模板名称搜索', // 采集时机：输入内容确定筛选后
    M_B_T_W_S_1: '选择模板类型', // 特殊属性：addition: { type: 'MARKETING' } MARKETING-市场营销 UTILITY-交易相关 AUTHENTICATION-身份验证
    M_B_T_W_S_2: '选择账号状态', // 特殊属性：addition: { type: 'PASSED' } PASSED-账号正常 BANNED-账号封禁
    M_B_T_W_S_3: '选择业务账号',
    M_B_T_W_S_4: '选择模板语言', // 特殊属性：addition: { type: 'af' } af-南非语
    M_B_T_W_S_5: '选择模板状态', // 特殊属性：addition: { type: 'APPROVED' } APPROVED-有效 PENDING-WhatsApp官方审核中 REJECTED-拒绝 FAILED-提交失败
    M_B_T_W_S_6: '模板标签名搜索', // 采集时机：输入内容确定筛选后

    M_B_T_W_R: '重置',
    M_B_T_W_S: '同步模板',
    M_B_T_W_A: '添加新模板',
    M_B_T_W_A_0: '添加新模板_提交',
    M_B_T_W_A_1: '添加新模板_取消',

    M_B_T_W_P_0: '复制',
    M_B_T_W_P_1: '删除',
    M_B_T_W_P_1_0: '删除_确定',
    /* WhatsApp Api模板 end */

    /* Email模板 start */
    M_B_T_E_S: '模板名称搜索',
    M_B_T_E_C: '创建模板',
    M_B_T_E_C_0: '创建模板_创建',
    M_B_T_E_C_0_0: '创建模板_创建_保存',
    M_B_T_E_C_0_1: '创建模板_创建_取消',
    M_B_T_E_P_0: '创建计划',
    M_B_T_E_P_1: '编辑',
    M_B_T_E_P_2: '复制',
    M_B_T_E_P_3: '删除',
    M_B_T_E_P_3_0: '删除_确定',
    /* Email模板 end */

    /* Messenger模板 start */
    M_B_T_M_S: '模板搜索',
    M_B_T_M_C: '创建新模板',
    M_B_T_M_C_0: '创建新模板_保存',
    M_B_T_M_C_1: '创建新模板_取消',

    M_B_T_M_R_0: '刷新',
    M_B_T_M_R_1: '状态刷新',
    M_B_T_M_R_2: '新建模板',
    M_B_T_M_R_3: '选用官方模板库',

    M_B_T_M_P_0: '复制',
    M_B_T_M_P_1: '查看',
    M_B_T_M_P_2: '编辑',
    M_B_T_M_P_3: '选用',
    M_B_T_M_P_4: '发送',
    /* Messenger模板 end */

    /* 分流链接 start */
    M_B_L_S: '分流链接搜索', // 采集时机：输入内容确定筛选后
    M_B_L_C: '创建链接',
    M_B_L_C_0: '创建链接_完成创建',
    M_B_L_C_1: '创建链接_取消',

    M_B_L_N: '分流链接',
    M_B_L_P: '启用/停用分流状态', // 特殊属性：addition: { status: '1' } 0-停用 1-启用

    M_B_L_P_0: '推广',
    M_B_L_P_0_0: '推广_关闭', // 采集时机：点击取消、关闭按钮，点击其他区域收起弹窗时
    M_B_L_P_0_1: '推广_下载',
    M_B_L_P_0_2: '推广_复制',
    M_B_L_P_1: '洞察',
    M_B_L_P_1_0: '洞察_导出',
    M_B_L_P_2: '编辑',
    M_B_L_P_2_0: '编辑_保存',
    M_B_L_P_3: '删除',
    M_B_L_P_3_0: '删除_确定',
    /* 分流链接 end */
};
